module.exports = __webpack_public_path__ + "img/symbol_5.42d24846.png";